
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[topic]",
      function () {
        return require("private-next-pages/resources/[topic]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/[topic]"])
      });
    }
  